import { render, staticRenderFns } from "./dateData.vue?vue&type=template&id=557e2286&scoped=true&"
import script from "./dateData.vue?vue&type=script&lang=js&"
export * from "./dateData.vue?vue&type=script&lang=js&"
import style0 from "./dateData.vue?vue&type=style&index=0&id=557e2286&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557e2286",
  null
  
)

export default component.exports